'use client';
import { BaseContentResponse } from 'lib/services/models/content-response';
import { pushToDataLayer, DataLayerEvent } from 'components/helpers/Global/Analytics/DataLayer';

export const sendContentResultAnalytics = ({
  content,
  language,
  contentType,
  recordType,
  contentListName,
  templateName,
}: {
  content: Partial<BaseContentResponse>;
  language: string | undefined | null;
  contentType: string;
  recordType?: string;
  contentListName: string;
  templateName: string;
}): void => {
  const contentTypeValue = contentType;
  const recordTypeValue = recordType;

  const payload: DataLayerEvent = {
    event: 'content_result',
    content_id: content?.ContentId || '',
    content_title: content?.Title || '',
    content_type: contentTypeValue,
    record_type: recordTypeValue,
    content_list_name: contentListName,
    language: (language || 'en').toLowerCase(),
    template_name: templateName,
  };

  pushToDataLayer(payload);
};
